import { prop } from "ramda";
import React, { useMemo } from "react";
import { FaExchangeAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAccountID } from "../store/account";
import { useAccounts } from "../api/accounts";
import DropMenu from "../shared/InaccessibleMenu";
import { createPortal } from "react-dom";

export default function AccountsMenu() {
    const navigate = useNavigate();
    const accountID = useAccountID();
    const { data: accounts } = useAccounts();

    const items = useMemo(() => {
        if (!accounts) return [];

        return accounts.map(a => ({
            label: a.accountName,
            path: `/dashboard/${a.accountID}`,
            className: a.accountID == accountID ? "active" : ""
        }));
    }, [accounts, accountID]);

    // Don't need a menu if there's nothing to switch to
    if (items.length < 2) return null;

    return (
        <DropMenu>
            {({
                isOpen,
                createWrapperProps,
                createButtonProps,
                createMenuProps,
                createItemProps
            }) => (
                <span
                    {...createWrapperProps({
                        className: "drop-menu"
                    })}
                >
                    <button
                        {...createButtonProps({
                            className: isOpen ? "active" : undefined
                        })}
                    >
                        <FaExchangeAlt />
                        <span className="tip" role="tooltip">
                            Switch Accounts
                        </span>
                    </button>
                    {isOpen ? createPortal(
                        <ul {...createMenuProps({ className: "drop-menu-menu" })}>
                            {items.map((item, i) => (
                                <li
                                    key={i}
                                    {...createItemProps({
                                        onClick() {
                                            navigate(item.path);
                                        }
                                    })}
                                    className={item.className}
                                >
                                    {item.label}
                                </li>
                            ))}
                        </ul>,
                        document.body
                    ) : null}
                </span>
            )}
        </DropMenu>
    );
}
